import styled from 'styled-components';
import { darkBlue } from '../../../utils/theme';

const GRADIENT_WIDTH = '250';

export const Item = styled.div`
  /* >div {
    max-height: 63vh;
    max-width: 112vh;
    margin: 0 auto;

    &:before {
      content: '';
      width: calc((100% - 112vh)/2);
      height: 100%;
      background: linear-gradient(270deg,  #000 0px, ${darkBlue} ${GRADIENT_WIDTH}px);
      position: absolute;
      left: 0;
      top: 0;
    }
    &:after {
      content: '';
      width: calc((100% - 112vh)/2);
      height: 100%;
      background: linear-gradient(90deg, #000 0px,  ${darkBlue} ${GRADIENT_WIDTH}px);
      position: absolute;
      right: 0;
      top: 0;
    }
  }
   */
  display: block !important;
`;



// WEBPACK FOOTER //
// ./src/components/carousel/styles/carousel-item.style.js